var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M12.5 4A6.5 6.5 0 1 1 10 16.502 6.5 6.5 0 1 1 10 4.499 6.471 6.471 0 0 1 12.5 4Zm0 1c-.448 0-.884.054-1.302.155A6.49 6.49 0 0 1 14 10.5a6.493 6.493 0 0 1-2.8 5.346A5.5 5.5 0 1 0 12.5 5Zm-5 0a5.5 5.5 0 1 0 1.302 10.845A6.49 6.49 0 0 1 6 10.5a6.493 6.493 0 0 1 2.8-5.346A5.526 5.526 0 0 0 7.5 5Zm2.5.6-.156.083A5.5 5.5 0 0 0 10 15.4 5.501 5.501 0 0 0 10 5.6Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlend);
export default ForwardRef;